import angular from 'angular';
import moment from 'moment';

module.exports = angular.module('common.services.work-order-starting', [])
.factory('workOrderStarting', function() {
  let service = {};

  service.tooEarlyToStartWork = (workOrder) => {
    if (!workOrder) return 'true';
    if (workOrder.kind !== 'renovation') return false;
    if (!workOrder.earliest_start_date) return false;
    let earliestStart = moment(workOrder.earliest_start_date);
    return earliestStart.isAfter(moment());
  };

  service.canStartWork = (workOrder) => {
    if (!workOrder) return false;
    if (workOrder.state !== 'budget_approved') return false;
    return !service.tooEarlyToStartWork(workOrder);
  };
  return service;
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/services/work-order-starting.js
 **/